import React from 'react';
import '../styles/Statistics.css'
function Statistics() {
  return (
      <section className='Statistics'>
         <div className='Statistics-div'>
         <h3 className='Statistics-header'>Advanced Statistics</h3>
          <p className='Statistics-text'>
          Track how your links are performing across the web with our  <br />
       advanced statistics dashboard.
          </p>
         </div>
      </section>
  );
}

export default Statistics;
